"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRubySpiClient = void 0;
const accounts_1 = require("../accounts");
const apple_auth_1 = require("../apple-auth");
const apple_channels_1 = require("../apple-channels");
const apple_proxy_1 = require("../apple-proxy");
const apple_replica_1 = require("../apple-replica");
const attribution_1 = require("../attribution");
const budgets_1 = require("../budgets");
const egress_1 = require("../egress");
const errors_1 = require("../errors");
const history_1 = require("../history");
const ingress_spi_1 = require("../ingress/ingress-spi");
const notifications_1 = require("../notifications");
const organic_replica_1 = require("../organic-replica");
const payments_1 = require("../payments");
const rules_1 = require("../rules");
const services_1 = require("../services");
function createRubySpiClient(networkClient) {
    return {
        accounts: (0, accounts_1.accountSpiClient)(networkClient),
        appleAuth: (0, apple_auth_1.appleAuthSpiClient)(networkClient),
        appleChannels: (0, apple_channels_1.appleChannelSpiClient)(networkClient),
        appleProxy: (0, apple_proxy_1.appleProxySpiClient)(networkClient),
        appleReplica: (0, apple_replica_1.appleReplicaSpiClient)(networkClient),
        attributions: (0, attribution_1.attributionSpiClient)(networkClient),
        budgets: (0, budgets_1.budgetSpiClient)(networkClient),
        egress: (0, egress_1.egressSpiClient)(networkClient),
        errors: (0, errors_1.errorSpiClient)(networkClient),
        history: (0, history_1.historySpiClient)(networkClient),
        ingress: (0, ingress_spi_1.ingressSpiClient)(networkClient),
        notifications: (0, notifications_1.notificationSpiClient)(networkClient),
        payments: (0, payments_1.paymentSpiClient)(networkClient),
        rules: (0, rules_1.rulesSpiClient)(networkClient),
        services: (0, services_1.servicesSpiClient)(networkClient),
        organicReplica: (0, organic_replica_1.organicReplicaSpiClient)(networkClient),
        log: networkClient.log,
    };
}
exports.createRubySpiClient = createRubySpiClient;
